export const RADIO = {
  "Radio.Unselected.Border.Color": {
    ref: "Color.Gray.400"
  },
  "Radio.Selected.Border.Color": {
    ref: "Color.Primary.500"
  },
  "Radio.Selected.Circle.Color": {
    ref: "Color.Primary.500"
  },
  "Radio.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Radio.Color": {
    ref: "Input.Color"
  },
  "Radio.Font.Weight": {
    ref: "Input.Font.Weight"
  },
  "Radio.Line.Height": {
    ref: "Input.Line.Height"
  },
  "Radio.Letter.Spacing": {
    ref: "Input.Letter.Spacing"
  },
  "Radio.Spacing": {
    ref: "Space.8"
  },
  "Radio.Items.Spacing": {
    ref: "Space.8"
  },
  "Radio.Button.Size": {
    defaultValue: "18px"
  },
  "Radio.Selected.Circle.Size": {
    ref: "Space.8"
  },
  "Radio.Readonly.Border.Color": {
    ref: "Color.Gray.300"
  },
  "Radio.Selected.Circle.Readonly.Color": {
    ref: "Color.Gray.300"
  },
  "Radio.Disabled.Border.Color": {
    ref: "Color.Gray.200"
  },
  "Radio.Selected.Circle.Disabled.Color": {
    ref: "Color.Gray.200"
  },
  "Radio.Disabled.Text.Color": {
    ref: "Color.Gray.300"
  }
};
